<template>
  <div class="image__preview">
     <el-image 
        style="width: 100px; height: 100px"
        :src="imgUrl" 
        :preview-src-list="imgSrcList">
  </el-image>
  </div>
</template>
<script>
export default {
  name: "imageView",
  props: {
    url: {
		type: String,
		default () {
			return ""
		}
	},
	srcList: {
		type: Array,
		default () {
			return []
		}
	}
  },
  data() {
    return {
        imgUrl:"",
        imgSrcList:[],
    }
  },
  onLoad() {
      this.imgUrl = this.url;
      this.s=imgSrcList = this.srcList;

  },
  methods: {

  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/push/component/image-view.vue